import { render, staticRenderFns } from "./RefillMethods.vue?vue&type=template&id=474e2456&"
import script from "./RefillMethods.vue?vue&type=script&lang=js&"
export * from "./RefillMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports